import * as React from 'react';

import {FieldData, FormContext, FormGroup} from './FormContext';
import {Text, TextContext} from '../../TextContext';
import {FormRadio} from './FormRadio';
import {FormCheckbox} from './FormCheckbox';
import {FormText} from './FormText';
import {FormTextarea} from './FormTextarea';

type FormProps = {
    text: Text;
};

// tslint:disable-next-line function-name max-func-body-length
export function Form(props: FormProps): JSX.Element {
    const {data, dispatch} = React.useContext(FormContext);
    const text: Text = React.useContext(TextContext);

    function renderSuccess(): JSX.Element {
        return (
            <div className="c-review-form">
                <h1 className="c-review-form__title">
                    {props.text.success_title}
                </h1>
                <p className="c-review-form__body  s-wordpress">
                    {props.text.success_text}
                </p>
            </div>
        );
    }

    function submit(event: React.FormEvent): void {
        event.preventDefault();

        dispatch({type: 'SEND', payload: {}});
    }

    function renderFields(
        group: FormGroup,
        fields: {
            [name: string]: FieldData;
        },
    ): JSX.Element[] {
        return Object.keys(fields).map(
            (key: string): JSX.Element => {
                const field: FieldData = fields[key];

                switch (field.type) {
                    case 'radio':
                        return (
                            <FormRadio key={key} group={group} field={field}/>
                        );
                    case 'checkbox':
                        return (
                            <FormCheckbox
                                key={key}
                                group={group}
                                field={field}
                            />
                        );
                    case 'textarea':
                        return (
                            <FormTextarea
                                key={key}
                                group={group}
                                field={field}
                            />
                        );
                    default:
                        return (
                            <FormText key={key} group={group} field={field}/>
                        );
                }
            },
        );
    }

    function renderForm(): JSX.Element {
        return (
            <form className="c-review-form">
                <h1 className="c-review-form__title">
                    {props.text.form_title}
                </h1>
                <p className="c-review-form__body  s-wordpress">
                    {props.text.review_p1}
                </p>
                <p className="c-review-form__body  s-wordpress">
                    {props.text.review_p2}
                </p>
                <p className="c-review-form__body  s-wordpress">
                    {props.text.review_p3}
                </p>

                {renderFields('questions', data.questions)}

                <p className="c-review-form__body  s-wordpress">
                    {props.text.review_p4}
                </p>

                {renderFields('personal', data.personal)}

                <button
                    type="submit"
                    className="o-button  o-button--bordered  o-button--bordered-animated"
                    onClick={submit}
                >
                    {props.text.submit}
                </button>
            </form>
        );
    }

    if (data.send) {
        return renderSuccess();
    }

    return renderForm();
}
